//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------
export const createLessonSuccess = (returnedPayload) => ({ type: ActionTypes.super_lesson.createLessonSuccess, payload: returnedPayload });
export const updateLessonSuccess = (returnedPayload) => ({ type: ActionTypes.super_lesson.updateLessonSuccess, payload: returnedPayload });
export const listLessonSuccess = (returnedPayload) => ({ type: ActionTypes.super_lesson.listLessonSuccess, payload: returnedPayload });
export const deleteLessonSuccess = (returnedPayload) => ({ type: ActionTypes.super_lesson.deleteLessonSuccess, payload: returnedPayload });